import React, { useEffect, useContext } from "react";
import { withRouter } from "react-router";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import AuthContext from "../../context/authentication/authContext";
import useMediaQuery from "../../hooks/useMediaQuery";

import Loading from "../core/Loading";
import Stadistics from "../portal/Stadistics";
import MyAccount from "../portal/MyAccount";
import InfinityScroll from "../core/InfinityScroll";

import PortalContext from "../../context/portal/portalContext";

import "./Portal.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: "center",
    color: theme.palette.text.secondary,
    marginTop: "20px",
    marginLeft: "20px",
  },
  componentTitle: {
    fontSize: 18,
    padding: 10,
    marginLeft: 10,
    color: "#263AE3",
  },
}));

const Portal = (props) => {
  const authContext = useContext(AuthContext);
  const { authenticatedUser, closeSession, hasToChange } = authContext;
  const portalContext = useContext(PortalContext);
  const { getDashboardData, error, data, getDashboardBill,isBill } = portalContext;

  useEffect(() => {
   // //console.log(isBill)
    if(isBill==="ISBILL")
        getDashboardBill()
    else
      getDashboardData();
  }, [isBill]);

  useEffect(() => {
    authenticatedUser();
    if (localStorage.getItem("hasToChange") === "true") {
      props.history.push("/app/change-password?show-terms-of-use=1");
    }


  }, []);

 /*
  React.useEffect(()=>{
    //console.table(billData)
  },[billData])
*/
  const classes = useStyles();
  const isMobile = useMediaQuery("max-width", 600);

  if (error) {
    props.history.push("/app/error");
  }

  if(data){
  return (
    <div className={classes.root}>
      {!isMobile ? (
        <Grid container>
          <Grid item xs={12} sm={9}>
            <Paper className={classes.paper}>
              <Stadistics isBill={props.isBill} />
            </Paper>
            <Typography className={classes.componentTitle}>
              Mi cuenta
            </Typography>
            <Paper className={classes.paper}>
              <MyAccount isBill={props.isBill}/>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <InfinityScroll />
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          <Grid item xs={12} sm={9}>
            <Grid item xs={12} sm={3}>
              <InfinityScroll />
            </Grid>
            <Paper className={classes.paper}>
              <Stadistics isBill={props.isBill} data={data}/>
            </Paper>
            <Typography className={classes.componentTitle}>
              Mi cuenta
            </Typography>
            <Paper className={classes.paper}>
              <MyAccount isBill={props.isBill} />
            </Paper>
          </Grid>
        </Grid>
      )}
    </div>
  );

  }else return (<Loading/>)
};

export default withRouter(Portal);
